import * as React from 'react';
import CreateContext from '@99designs/apps/spa/pages/create/components/CreateContext';
import SiteFooter from '@99designs/apps/spa/pages/create/components/SiteFooter';
import defaultSite from '@99designs/shared-configuration/dist/sites/99designs.com.json';
import { GlobalNav, GlobalNavDrawers, SiteHeader } from '@99designs/site-navigation';
import { Site } from '@99designs/site-navigation/lib/Site';

interface Props {
    children?: React.ReactNode;
    variations?: string[];
}

export const LayoutContext = React.createContext({
    footerRef: React.createRef<HTMLDivElement>(),
});

const Layout = ({ children, variations }: Props) => {
    const footerRef = React.createRef<HTMLDivElement>();

    return (
        <CreateContext.Consumer>
            {({ site, role }) => (
                <GlobalNav>
                    {({ toggleDrawer, drawerState }) => {
                        const globalNavSite = new Site(
                            site
                                ? {
                                      domain: site.domain,
                                      'phone.support': site.phoneSupport,
                                      'phone.office_hours': site.phoneOfficeHours
                                          ? site.phoneOfficeHours
                                          : '',
                                      locale: site.locale,
                                      accepted_locales: site.acceptedLocales.map(
                                          (acceptedLocale) => acceptedLocale.tag
                                      ),
                                  }
                                : defaultSite
                        );

                        return (
                            <div
                                className={`layout ${
                                    variations && variations.map((v) => `layout--${v}`)
                                }`}
                            >
                                {role && globalNavSite && (
                                    <div className="max--desktop">
                                        <SiteHeader
                                            role={role}
                                            site={globalNavSite}
                                            variations={[]}
                                            onLeftDrawerTriggerClick={toggleDrawer('left', true)}
                                            onRightDrawerTriggerClick={toggleDrawer('right', true)}
                                            focused
                                        />
                                    </div>
                                )}

                                <div className="layout__content">
                                    <LayoutContext.Provider value={{ footerRef }}>
                                        {children}
                                    </LayoutContext.Provider>
                                </div>

                                {role && globalNavSite && (
                                    <GlobalNavDrawers
                                        toggleDrawer={toggleDrawer}
                                        role={role}
                                        site={globalNavSite}
                                        drawerState={drawerState}
                                    />
                                )}
                                <div className="layout__footer" ref={footerRef}>
                                    <div className="max--desktop">
                                        <div className="row">
                                            <SiteFooter />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        );
                    }}
                </GlobalNav>
            )}
        </CreateContext.Consumer>
    );
};

export default Layout;
